import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import { StoreProvider } from "./context/StoreContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CompareBar } from "./components/CompareBar";
import { AdvisorWidget } from "./components/AdvisorWidget";
import { CartDrawer } from "./components/CartDrawer";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Advisor from "./pages/Advisor";
import Simulator from "./pages/Simulator";
import Compare from "./pages/Compare";
import Bundles from "./pages/Bundles";
import Accessories from "./pages/Accessories";
import Wholesale from "./pages/Wholesale";
import Contact from "./pages/Contact";
import StaticPage from "./pages/StaticPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App dark min-h-screen bg-background text-foreground">
      <LanguageProvider>
        <StoreProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/category/:slug" element={<Shop />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/advisor" element={<Advisor />} />
                <Route path="/simulator" element={<Simulator />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/bundles" element={<Bundles />} />
                <Route path="/accessories" element={<Accessories />} />
                <Route path="/wholesale" element={<Wholesale />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<StaticPage kind="about" />} />
                <Route path="/faq" element={<StaticPage kind="faq" />} />
                <Route path="/shipping" element={<StaticPage kind="shipping" />} />
                <Route path="/warranty" element={<StaticPage kind="warranty" />} />
                <Route path="/privacy" element={<StaticPage kind="privacy" />} />
                <Route path="/terms" element={<StaticPage kind="terms" />} />
              </Routes>
            </main>
            <Footer />
            <CompareBar />
            <AdvisorWidget />
            <CartDrawer />
            <Toaster position="top-center" theme="dark" richColors closeButton />
          </BrowserRouter>
        </StoreProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
